import React from 'react';
import FaqHero from '../components/faq/FaqHero';
import FaqList from '../components/faq/FaqList';
import FaqCta from '../components/faq/FaqCta';

const FaqPage = () => (
  <main>
    <FaqHero />
    <FaqList />
    <FaqCta />
  </main>
);

export default FaqPage;